import ZapierLogo from './../../../assets/images/zapier_logo.svg'
import PinghomeLogo from './../../../assets/images/pinghome_logo.svg'
import {SimpleBlueButton} from '../../../components/core/button'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import CustomSelect from '../../../components/core/customSelect'
import Customer from './../../../utils/customer'
import {useSelector} from 'react-redux'
import {useState} from 'react'
import integrationService from '../../../api/integration'
import text from './../text.json'
import {toast} from 'react-toastify'

const AuthClient = ({closePopup, data}) => {
    const fieldNames = {
        team_id: 'team_id'
    }
    const [teamId, setTeamId] = useState(Customer.getCurrentUserTeamId())
    const [active, setActive] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const teams = useSelector(state => state.teams.teams)
    const localTeams = teams?.map(item => {
        return {
            ...item,
            disabled: false,
            label: <span className="d-flex justify-content-between align-items-center gap-half">
                {item.label}
            </span>
        }
    })
    const team = teams.find(item => item.value === teamId)

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const integrateableServices = {
        zapier: {
            logo: ZapierLogo
        }
    }

    const handleClick = async(e) => {
        e.preventDefault()
        setIsSubmitting(true)
        try {
            const response = await integrationService.addZapierIntegration({
                team_id: teamId,
                client_id: data?.clientId,
                redirect_uri: data?.redirectUri,
                state: data?.state,
                scopes: data?.scopes,
                response_type: data?.responseType
            })
            setIsSubmitting(false)
            if (response?.data?.data?.redirect_url) {
                window.location.href = response?.data?.data?.redirect_url
                closePopup()
                return
            }
            toast.error(response?.data?.message)
        } catch (e) {
            toast.error(e?.response?.message)
            setIsSubmitting(false)
        }
    }

    return (
        <div className="auth">
            <div className="logos">
                <div className="img-container">
                    <img src={integrateableServices[data?.clientData?.type]?.logo} alt={data?.clientData?.type} />
                </div>
                <div className="img-container">
                    <img src={PinghomeLogo} alt="Pinghome" />
                </div>
            </div>
            <span className="desc">{data?.clientData?.description}</span>

            <form className="modal-body">
                <CustomSelect
                    placeholder={text.team}
                    onChange={(name, data) => setTeamId(data?.team_id)}
                    infoText={text.team_info}
                    name={fieldNames.team_id}
                    value={team}
                    options={localTeams}
                    defaultFirst={true}
                    checkboxClassName="multiselect"
                    activeInfo={active === fieldNames.team_id}
                    handleInfo={(state) => handleInfo(fieldNames.team_id, state)}
                    isDisabled={false}
                />
                <SimpleBlueButton
                    onClick={e => handleClick(e)}
                    type="submit"
                    disabled={isSubmitting}
                >
                    {isSubmitting && <ButtonLoader/>}
                    {text.auth}
                </SimpleBlueButton>
            </form>
        </div>
    )
}

export default AuthClient
